<template>
  <c-page-blank>
    <c-page-main-content class="px-15">
      <slot />
    </c-page-main-content>
  </c-page-blank>
</template>
